import React from 'react';
import { connect } from 'react-redux';
import classnames from 'classnames';
import PropTypes from 'prop-types';

import { useIntl, FormattedMessage } from 'react-intl';

import { withStyles } from '@material-ui/core/styles';
import {
	FormControlLabel,
	Switch,
	FormControl,
	FormHelperText,
	Select,
	MenuItem
} from '@material-ui/core';

import * as appPropTypes from '../appPropTypes';
import { withRoomContext } from '../../RoomContext';
import * as settingsActions from '../../actions/settingsActions';
import Logger from '../../Logger';

const logger = new Logger('AppearanceSettings');

const styles = (theme) =>
	({
		setting :
		{
			padding : theme.spacing(2)
		},
		formControl :
		{
			display : 'flex',
			padding : theme.spacing(1),
			marginLeft : theme.spacing(2)
		},
		switchLabel : {
			justifyContent : 'space-between',
			flex           : 'auto',
			display        : 'flex',
			padding        : theme.spacing(1),
			marginRight    : 0
		}
	});

const AppearanceSettings = ({
	roomClient,
	settings,
	onToggleShowNotifications,
	onToggleNotificationSounds,
	classes,
	lang,
	localesList
}) =>
{
	const intl = useIntl();

	return (
		<React.Fragment>
			<FormControlLabel
				className={classnames(classes.setting, classes.switchLabel)}
				control={<Switch checked={settings.showNotifications} onChange={onToggleShowNotifications} value='showNotifications' />}
				labelPlacement='start'
				label={intl.formatMessage({
					id             : 'settings.showNotifications',
					defaultMessage : 'Show Notifications'
				})}
			/>

			<FormControlLabel
				className={classnames(classes.setting, classes.switchLabel)}
				control={<Switch checked={settings.notificationSounds} onChange={onToggleNotificationSounds} value='notificationSounds' />}
				labelPlacement='start'
				label={intl.formatMessage({
					id             : 'settings.notificationSounds',
					defaultMessage : 'Notification Sounds'
				})}
			/>


			{window.config.showLangSwitch && <FormControl className={classes.formControl}>
				<FormHelperText
					classes={{
						root: classes.formItemLabel
					}}
				>
					<FormattedMessage
						id='settings.locale'
						defaultMessage='Select Language'
					/>
				</FormHelperText>

				<Select
					classes={{
						root: classes.formItem
					}}
					defaultValue={lang}
					onChange={(event) =>
					{
						const _lang = event.target.value;
						logger.debug(`选择了 [${_lang}] 语言`);

						roomClient.setLocale(_lang);

					}}
					autoWidth
					className={classes.selectEmpty}
				>
					{ localesList.map((item, index) =>
					{
						return (
							<MenuItem
								classes={{
									root: classes.formItem
								}}
								key={index}
								value={item.locale[0]}
							>
								{item.name}
							</MenuItem>
						);
					})}
				</Select>
			</FormControl>}

		</React.Fragment>
	);
};

AppearanceSettings.propTypes =
{
	roomClient                  : PropTypes.any.isRequired,
	isMobile                    : PropTypes.bool.isRequired,
	room                        : appPropTypes.Room.isRequired,
	settings                    : PropTypes.object.isRequired,
	onToggleShowNotifications   : PropTypes.func.isRequired,
	onToggleNotificationSounds  : PropTypes.func.isRequired,
	classes                     : PropTypes.object.isRequired,
	lang                        : PropTypes.string.isRequired,
	localesList                 : PropTypes.array.isRequired

};

const mapStateToProps = (state) =>
	({
		isMobile     : state.me.browser.platform === 'mobile',
		room         : state.room,
		settings     : state.settings,
		lang         : state.intl.lang,
		localesList  : state.intl.list
	});

const mapDispatchToProps = {
	onToggleShowNotifications : settingsActions.toggleShowNotifications,
	onToggleNotificationSounds : settingsActions.toggleNotificationSounds
};

export default withRoomContext(connect(
	mapStateToProps,
	mapDispatchToProps,
	null,
	{
		areStatesEqual : (next, prev) =>
		{
			return (
				prev.settings === next.settings &&
				prev.intl.lang === next.intl.lang &&
				prev.intl.localesList === next.intl.localesList
			);
		}
	}
)(withStyles(styles)(AppearanceSettings)));